import React from "react";

import "./Steps.css";

interface RfrInputNameProps {
    label: string,
    required: boolean;
    name: string,
    className?: string,
    placeholderfirst: string,
    placeholderlast: string,
    onInput: (e: string) => void;
    data: Record<string, unknown> | undefined;
}

export default function RfrInputName(props: RfrInputNameProps) {

    return (
        <>
            <div className="rfr-form-row">
                <div className="rfr-form-row-desc">
                    {props.required ?
                        <div className="row-desc-required">*</div>
                        :
                        <div className="row-desc-required"></div>
                    }
                    <div className="max-wdith-desc">
                        <label htmlFor={props.name} className="font-blue">{props.label}:</label>
                    </div>
                </div>
                <div className="rfr-input-block">
                    <input onChange={(e) => props.onInput(e)} type="text" name={props.name + "First"} id={props.name + "First"} className="rfr-form-input-mid" value={props.data[props.name + "First"]} placeholder={props.placeholderfirst} />
                    <input onChange={(e) => props.onInput(e)} type="text" name={props.name + "Last"} id={props.name + "Last"} className="rfr-form-input-mid" value={props.data[props.name + "Last"]} placeholder={props.placeholderlast} />
                </div>
            </div>
        </>
    )
}